


/////////////////////////////////////////////////////////////////////////
// ANIM HELPERS /////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const AnimHelpers = {

  init: function(game) {

    this.game = game;

    this._extensions();
  },
  
  addAnimationData: function(sprite, animData) {

    if (animData) {

      animData.forEach(function(anim) {
        
        var frameNames = anim.frameNames || Phaser.Animation.generateFrameNames(anim.nameRoot, anim.frame1, anim.frameLast, '.png', 3);
        if (anim.reverse) {
          frameNames.reverse();
        }
        if (anim.andReverse) {
          let reversedFrames = frameNames.slice();
          frameNames = frameNames.concat(reversedFrames.reverse());
        }
        sprite.animations.add(anim.label, frameNames);

      });

    }

  },

  fadeIn: function(element, tweenTime, $delay, $targetAlpha) {

    if (element.visible)
      return;

    var targetAlpha = (typeof $targetAlpha !== 'undefined') ? $targetAlpha : 1.0;
    var delay = (typeof $delay !== 'undefined') ? $delay : 0;

    element.alpha = 0;
    element.visible = true;
    return this.game.add.tween(element).to({alpha: targetAlpha}, tweenTime, Phaser.Easing.Linear.None, true, delay); 

  },

  fadeOut: function(element, tweenTime, $delay, $targetAlpha) {

    if (!element.visible)
      return;

    var targetAlpha = (typeof $targetAlpha !== 'undefined') ? $targetAlpha : 0;
    var delay = (typeof $delay !== 'undefined') ? $delay : 0;

    var fadeTween = this.game.add.tween(element).to({alpha: targetAlpha}, tweenTime, Phaser.Easing.Linear.None, true, delay);
    fadeTween.onComplete.add(function() {
      
      if (targetAlpha === 0) {
        element.visible = false;
      }
      

    }, this); 

    return fadeTween;
  },

  _extensions: function() {

    // EXTEND complete on Phaser.Animation to set _frameIndex to _frames.length-1    
    /**
    * Called internally when the animation finishes playback.
    * Sets the isPlaying and isFinished states and dispatches the onAnimationComplete event if it exists on the parent and local onComplete event.
    *
    * @method Phaser.Animation#complete
    */
    Phaser.Animation.prototype.complete = function () {

      this.isPlaying = false;
      this.isFinished = true;
      this.paused = false;

      this._parent.events.onAnimationComplete$dispatch(this._parent, this);

      // RCL fix - animation doesn't stop on last frame if frames are skipped due to low fps
      this._frameIndex = this._frames.length-1;
      ////

      this.onComplete.dispatch(this._parent, this);

      if (this.killOnComplete)
      {
          this._parent.kill();
      }

    };    
      
    // EXTEND Tween class to allow us to 'finish' a tween.
    // To finish is to call stop() on the tween AND set properties to their final resting point.
    Phaser.Tween.prototype.finish = function() {

      // set the tweens to their end props
      for (var i = 0; i < this.timeline.length; i++)
      {
          this.timeline[i].setProgress(1);
      }

      // stop, and call onComplete
      this.stop(true);

    };

    // We also need to extend TweenData to set us to a certain % of the time for the tween
    Phaser.TweenData.prototype.setProgress = function(progress) {

      for (var property in this.vEnd)
      {
          var start = this.vStart[property];
          var end = this.vEnd[property];

          if (Array.isArray(end))
          {
              this.parent.target[property] = this.interpolationFunction(end, progress);
          }
          else
          {
              this.parent.target[property] = start + ((end - start) * progress);
          }
      }


    };

    // And a function on the tween manager to let us finish tweens of a given object
    Phaser.TweenManager.prototype.finishFrom = function(obj, children) {

      if (typeof children === 'undefined') { children = true; }

      var i;
      var len;

      if (Array.isArray(obj))
      {
          for (i = 0, len = obj.length; i < len; i++)
          {
              this.finishFrom(obj[i]);
          }
      }
      else if (obj.type === Phaser.GROUP && children)
      {
          for (var i = 0, len = obj.children.length; i < len; i++)
          {
              this.finishFrom(obj.children[i]);
          }
      }
      else
      {
          for (i = 0, len = this._tweens.length; i < len; i++)
          {
              if (obj === this._tweens[i].target)
              {
                  this._tweens[i].finish();
              }
          }

          for (i = 0, len = this._add.length; i < len; i++)
          {
              if (obj === this._add[i].target)
              {
                  this._add[i].finish();
              }
          }
      }

    };
  }
};

export default AnimHelpers;




// WEBPACK FOOTER //
// ./app/src/utils/misc/AnimHelpers.js